import React from 'react';

const Loader = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '25vh' }}>
      <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
